// // src/pages/LoginPage.js
// // Two-step: password → TOTP verification → admin_profiles check
// import { useState } from 'react'
// import { supabase } from '../lib/supabaseClient'
// import { ShieldCheck, Eye, EyeOff, KeyRound } from 'lucide-react'

// export default function LoginPage({ onLogin }) {
//   const [step,     setStep]     = useState('password') // 'password' | 'totp'
//   const [email,    setEmail]    = useState('')
//   const [password, setPassword] = useState('')
//   const [totpCode, setTotpCode] = useState('')
//   const [factorId, setFactorId] = useState(null)
//   const [challengeId, setChallengeId] = useState(null)
//   const [showPw,   setShowPw]   = useState(false)
//   const [loading,  setLoading]  = useState(false)
//   const [error,    setError]    = useState('')
//   const isCanteenDomain = window.location.hostname.includes('canteen');

//   // ── Step 1: password login ─────────────────────────────────
//   const handlePassword = async (e) => {
//     e.preventDefault()
//     setLoading(true); setError('')

//     const { data, error: authErr } = await supabase.auth.signInWithPassword({ email, password })
//     if (authErr) { setError(authErr.message); setLoading(false); return }

//     // Verify admin identity before proceeding to MFA
//     const { data: profile } = await supabase
//       .from('admin_profiles').select('user_id').eq('user_id', data.user.id).single()

//     if (!profile) {
//       await supabase.auth.signOut()
//       setError('Access denied.')
//       setLoading(false)
//       return
//     }

//     // Check if MFA is enrolled
//     const { data: mfaData } = await supabase.auth.mfa.listFactors()
//     const totp = mfaData?.totp?.[0]

//     if (!totp) {
//       // First login — need to enroll TOTP
//       setStep('enroll')
//       setLoading(false)
//       return
//     }

//     // Challenge the existing TOTP factor
//     const { data: challengeData, error: challengeErr } = await supabase.auth.mfa.challenge({ factorId: totp.id })
//     if (challengeErr) { setError(challengeErr.message); setLoading(false); return }

//     setFactorId(totp.id)
//     setChallengeId(challengeData.id)
//     setStep('totp')
//     setLoading(false)
//   }

//   // ── Step 2: TOTP verification ─────────────────────────────
//   const handleTotp = async (e) => {
//     e.preventDefault()
//     setLoading(true); setError('')

//     const { error: verifyErr } = await supabase.auth.mfa.verify({
//       factorId,
//       challengeId,
//       code: totpCode.replace(/\s/g, ''),
//     })

//     if (verifyErr) {
//       setError('Invalid code. Try again.')
//       setLoading(false)
//       return
//     }

//     // MFA passed — fetch full session
//     const { data: { session } } = await supabase.auth.getSession()
//     onLogin(session)
//     setLoading(false)
//   }

//   const inputCls = `w-full bg-[#1c1c1e] border border-white/10 text-white placeholder-gray-600
//     px-4 py-3 rounded-xl focus:border-orange-500 focus:outline-none focus:ring-1
//     focus:ring-orange-500 transition-all text-sm font-mono`

//   return (
//     <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-6">
//       <div className="w-full max-w-sm">

//         {/* Header */}
//         <div className="text-center mb-8">
//           <div className="w-14 h-14 bg-orange-500/10 rounded-2xl flex items-center justify-center mx-auto mb-4 border border-orange-500/20">
//             <ShieldCheck className="w-7 h-7 text-orange-500" />
//           </div>
//           <h1 className="text-white text-xl font-semibold tracking-wide">
//             {isCanteenDomain ? 'Kitchen Portal' : 'Operations Portal'}
//           </h1>
//           <p className="text-gray-500 text-xs mt-1 tracking-wider uppercase">
//             {step === 'password' ? 'Secure access' : 'Two-factor verification'}
//           </p>
//         </div>

//         {/* Step indicator */}
//         <div className="flex items-center gap-2 mb-6">
//           {['password','totp'].map((s, i) => (
//             <div key={s} className="flex items-center gap-2 flex-1">
//               <div className={`w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold flex-shrink-0 ${
//                 step === s ? 'bg-orange-500 text-white' :
//                 (step === 'totp' && s === 'password') ? 'bg-green-500/20 text-green-400 border border-green-500/30' :
//                 'bg-white/5 text-gray-600'
//               }`}>{i + 1}</div>
//               {i === 0 && <div className="flex-1 h-px bg-white/10" />}
//             </div>
//           ))}
//         </div>

//         {error && (
//           <div className="bg-red-500/10 border border-red-500/20 rounded-xl p-3 mb-4 text-red-400 text-xs font-medium text-center">
//             {error}
//           </div>
//         )}

//         {/* Password step */}
//         {step === 'password' && (
//           <form onSubmit={handlePassword} className="space-y-3">
//             <input type="email" placeholder="Email" value={email}
//               onChange={e => setEmail(e.target.value)} required className={inputCls} />
//             <div className="relative">
//               <input type={showPw ? 'text' : 'password'} placeholder="Password"
//                 value={password} onChange={e => setPassword(e.target.value)}
//                 required className={inputCls + ' pr-10'} />
//               <button type="button" onClick={() => setShowPw(!showPw)}
//                 className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300">
//                 {showPw ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
//               </button>
//             </div>
//             <button type="submit" disabled={loading}
//               className="w-full bg-orange-500 text-white py-3 rounded-xl font-semibold text-sm
//                 tracking-wide disabled:opacity-50 transition-all hover:bg-orange-400 mt-2">
//               {loading ? 'Verifying...' : 'Continue →'}
//             </button>
//           </form>
//         )}

//         {/* TOTP step */}
//         {step === 'totp' && (
//           <form onSubmit={handleTotp} className="space-y-4">
//             <div className="bg-[#1c1c1e] border border-white/5 rounded-2xl p-4 text-center mb-2">
//               <KeyRound className="w-6 h-6 text-orange-500 mx-auto mb-2" />
//               <p className="text-gray-300 text-sm font-medium">Open your authenticator app</p>
//               <p className="text-gray-500 text-xs mt-1">Enter the 6-digit code for OrderQ</p>
//             </div>
//             <input
//               type="text"
//               inputMode="numeric"
//               placeholder="000 000"
//               maxLength={7}
//               value={totpCode}
//               onChange={e => setTotpCode(e.target.value.replace(/[^0-9 ]/g,''))}
//               className={inputCls + ' text-center text-2xl tracking-[0.4em] py-4'}
//               autoFocus
//             />
//             <button type="submit" disabled={loading || totpCode.replace(/\s/g,'').length !== 6}
//               className="w-full bg-orange-500 text-white py-3 rounded-xl font-semibold text-sm
//                 tracking-wide disabled:opacity-50 transition-all hover:bg-orange-400">
//               {loading ? 'Verifying...' : 'Verify & Enter'}
//             </button>
//             <button type="button" onClick={() => { setStep('password'); setTotpCode(''); setError('') }}
//               className="w-full text-gray-500 text-xs py-2 hover:text-gray-300 transition-colors">
//               ← Back to password
//             </button>
//           </form>
//         )}

//         {/* TOTP enroll step - first-time setup */}
//         {step === 'enroll' && <TOTPEnroll onDone={() => setStep('password')} email={email} />}
//       </div>
//     </div>
//   )
// }

// function TOTPEnroll({ onDone, email }) {
//   const [qrUrl,   setQrUrl]   = useState(null)
//   const [secret,  setSecret]  = useState(null)
//   const [fid,     setFid]     = useState(null)
//   const [code,    setCode]    = useState('')
//   const [loading, setLoading] = useState(false)
//   const [error,   setError]   = useState('')
//   const [started, setStarted] = useState(false)

//   const startEnroll = async () => {
//     setLoading(true)
//     const { data, error: err } = await supabase.auth.mfa.enroll({ factorType: 'totp', issuer: 'OrderQ', friendlyName: 'OrderQ Admin' })
//     if (err) { setError(err.message); setLoading(false); return }
//     setQrUrl(data.totp.qr_code)
//     setSecret(data.totp.secret)
//     setFid(data.id)
//     setStarted(true)
//     setLoading(false)
//   }

//   const verify = async (e) => {
//     e.preventDefault()
//     setLoading(true); setError('')
//     const { data: ch } = await supabase.auth.mfa.challenge({ factorId: fid })
//     const { error: ve } = await supabase.auth.mfa.verify({ factorId: fid, challengeId: ch.id, code })
//     if (ve) { setError('Invalid code.'); setLoading(false); return }
//     onDone()
//   }

//   const inputCls = `w-full bg-[#1c1c1e] border border-white/10 text-white placeholder-gray-600
//     px-4 py-3 rounded-xl focus:border-orange-500 focus:outline-none text-sm font-mono`

//   return (
//     <div className="space-y-4">
//       <div className="bg-amber-500/10 border border-amber-500/20 rounded-xl p-3 text-amber-400 text-xs text-center">
//         First login — set up your authenticator app
//       </div>
//       {!started ? (
//         <button onClick={startEnroll} disabled={loading}
//           className="w-full bg-orange-500 text-white py-3 rounded-xl font-semibold text-sm disabled:opacity-50">
//           {loading ? 'Generating QR...' : 'Set up Authenticator →'}
//         </button>
//       ) : (
//         <form onSubmit={verify} className="space-y-4">
//           <div className="bg-white rounded-2xl p-4 flex items-center justify-center">
//             <img src={qrUrl} alt="TOTP QR" className="w-44 h-44" />
//           </div>
//           <div className="bg-[#1c1c1e] rounded-xl p-3 text-center">
//             <p className="text-gray-500 text-[10px] uppercase tracking-widest mb-1">Manual entry key</p>
//             <p className="text-gray-200 text-xs font-mono tracking-widest break-all">{secret}</p>
//           </div>
//           <p className="text-gray-400 text-xs text-center">Scan with Google Authenticator or Authy, then enter the 6-digit code below</p>
//           <input type="text" inputMode="numeric" placeholder="000000" maxLength={6}
//             value={code} onChange={e => setCode(e.target.value.replace(/\D/g,''))}
//             className={inputCls + ' text-center text-xl tracking-widest'} autoFocus />
//           {error && <p className="text-red-400 text-xs text-center">{error}</p>}
//           <button type="submit" disabled={loading || code.length !== 6}
//             className="w-full bg-orange-500 text-white py-3 rounded-xl font-semibold text-sm disabled:opacity-50">
//             {loading ? 'Verifying...' : 'Confirm & Activate'}
//           </button>
//         </form>
//       )}
//     </div>
//   )
// }

// src/pages/LoginPage.js
import { useState } from 'react'
import { supabase } from '../lib/supabaseClient'
import { ShieldCheck, ChefHat, Eye, EyeOff, KeyRound } from 'lucide-react'
import { motion } from 'framer-motion'

export default function LoginPage({ onLogin }) {
  const [step,     setStep]     = useState('password') // 'password' | 'totp' | 'enroll'
  const [email,    setEmail]    = useState('')
  const [password, setPassword] = useState('')
  const [totpCode, setTotpCode] = useState('')
  const [factorId, setFactorId] = useState(null)
  const [challengeId, setChallengeId] = useState(null)
  const [showPw,   setShowPw]   = useState(false)
  const [loading,  setLoading]  = useState(false)
  const [error,    setError]    = useState('')

  // Dynamically change UI based on the URL they typed
  const isCanteenDomain = window.location.hostname.includes('canteen');

  // ── Step 1: Password Login & Role Routing ─────────────────────────────────
  const handlePassword = async (e) => {
    e.preventDefault()
    setLoading(true); setError('')

    const { data: authData, error: authErr } = await supabase.auth.signInWithPassword({ email, password })
    if (authErr) { setError(authErr.message); setLoading(false); return }

    const user = authData.user

    // 1. CHECK IF USER IS CANTEEN STAFF (Bypass MFA)
    if (user.user_metadata?.role === 'canteen_staff') {
      const { data: staffProfile } = await supabase
        .from('staff_profiles').select('canteen_id').eq('user_id', user.id).maybeSingle()

      if (staffProfile) {
        onLogin(authData.session)
        return 
      }
    }

    // 2. CHECK IF USER IS SUPER ADMIN (Require MFA)
    const { data: adminProfile } = await supabase
      .from('admin_profiles').select('user_id').eq('user_id', user.id).maybeSingle()

    if (!adminProfile) {
      await supabase.auth.signOut()
      setError('Access denied. No authorized profile found.')
      setLoading(false)
      return
    }

    // 3. Admin Verified -> Proceed to MFA checks
    const { data: mfaData } = await supabase.auth.mfa.listFactors()
    const totp = mfaData?.totp?.[0]

    if (!totp) {
      setStep('enroll')
      setLoading(false)
      return
    }

    const { data: challengeData, error: challengeErr } = await supabase.auth.mfa.challenge({ factorId: totp.id })
    if (challengeErr) { setError(challengeErr.message); setLoading(false); return }

    setFactorId(totp.id)
    setChallengeId(challengeData.id)
    setStep('totp')
    setLoading(false)
  }

  // ── Step 2: Admin TOTP Verification ─────────────────────────────
  const handleTotp = async (e) => {
    e.preventDefault()
    setLoading(true); setError('')

    const { error: verifyErr } = await supabase.auth.mfa.verify({
      factorId, challengeId, code: totpCode.replace(/\s/g, ''),
    })

    if (verifyErr) { setError('Invalid code. Try again.'); setLoading(false); return }

    const { data: { session } } = await supabase.auth.getSession()
    onLogin(session)
    setLoading(false)
  }

  // Unified sleek input styles
  const inputCls = `w-full bg-[#121212] border border-white/10 rounded-2xl px-5 py-4 text-white placeholder-gray-500 focus:border-[#f06e28] focus:outline-none focus:ring-1 focus:ring-[#f06e28] transition-all font-medium tracking-wide shadow-inner`

  return (
    <div className="min-h-screen bg-[#121212] flex items-center justify-center p-6 font-sans">
      <motion.div 
        initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }}
        className="bg-[#1c1c1e] rounded-[32px] shadow-[-4px_-4px_10px_rgba(255,255,255,0.02),4px_4px_15px_rgba(0,0,0,0.5)] border border-white/5 p-8 w-full max-w-sm relative overflow-hidden"
      >
        {/* Decorative background glow */}
        <div className="absolute -right-10 -top-10 w-40 h-40 bg-[#f06e28] opacity-5 rounded-full blur-3xl pointer-events-none"></div>

        {/* Header */}
        <div className="text-center mb-8 relative z-10">
          <div className="w-20 h-20 bg-[#f06e28]/10 rounded-3xl flex items-center justify-center mx-auto mb-5 border border-[#f06e28]/20 shadow-inner">
            {isCanteenDomain ? <ChefHat className="w-10 h-10 text-[#f06e28]" /> : <ShieldCheck className="w-10 h-10 text-[#f06e28]" />}
          </div>
          <h1 className="text-2xl font-heading font-extrabold tracking-wide text-white">
            {isCanteenDomain ? 'Kitchen Portal' : 'Operations Portal'}
          </h1>
          <p className="text-gray-400 text-xs font-bold tracking-widest uppercase mt-2">
            {step === 'password' ? 'Authorized Access Only' : 'Two-Factor Verification'}
          </p>
        </div>

        {error && (
          <div className="bg-red-500/10 border border-red-500/20 rounded-2xl p-4 mb-6 text-red-400 text-xs font-bold tracking-wider text-center">
            {error}
          </div>
        )}

        {/* Password step */}
        {step === 'password' && (
          <form onSubmit={handlePassword} className="space-y-5 relative z-10">
            <input type="email" placeholder="Email Address" value={email}
              onChange={e => setEmail(e.target.value)} required className={inputCls} />
            <div className="relative">
              <input type={showPw ? 'text' : 'password'} placeholder="Password"
                value={password} onChange={e => setPassword(e.target.value)}
                required className={inputCls + ' pr-12'} />
              <button type="button" onClick={() => setShowPw(!showPw)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300 transition-colors p-1">
                {showPw ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
              </button>
            </div>
            <button type="submit" disabled={loading}
              className="w-full bg-[#f06e28] text-white py-4 rounded-2xl font-bold tracking-widest uppercase text-sm shadow-[0_8px_20px_-4px_rgba(240,110,40,0.4)] disabled:opacity-50 transition-all active:scale-95 mt-2">
              {loading ? 'Authenticating...' : 'Sign In'}
            </button>
          </form>
        )}

        {/* TOTP step */}
        {step === 'totp' && (
          <form onSubmit={handleTotp} className="space-y-5 relative z-10">
            <div className="bg-[#121212] border border-white/5 rounded-2xl p-5 text-center mb-2 shadow-inner">
              <KeyRound className="w-8 h-8 text-[#f06e28] mx-auto mb-3" />
              <p className="text-gray-200 text-sm font-bold tracking-wide">Authenticator App</p>
              <p className="text-gray-500 text-xs mt-1 font-medium">Enter your 6-digit code</p>
            </div>
            <input
              type="text" inputMode="numeric" placeholder="000 000" maxLength={7}
              value={totpCode} onChange={e => setTotpCode(e.target.value.replace(/[^0-9 ]/g,''))}
              className={inputCls + ' text-center text-2xl tracking-[0.4em] py-5 font-bold'}
              autoFocus
            />
            <button type="submit" disabled={loading || totpCode.replace(/\s/g,'').length !== 6}
              className="w-full bg-[#f06e28] text-white py-4 rounded-2xl font-bold tracking-widest uppercase text-sm shadow-[0_8px_20px_-4px_rgba(240,110,40,0.4)] disabled:opacity-50 transition-all active:scale-95">
              {loading ? 'Verifying...' : 'Verify & Enter'}
            </button>
            <button type="button" onClick={() => { setStep('password'); setTotpCode(''); setError('') }}
              className="w-full text-gray-500 font-bold text-xs py-3 uppercase tracking-widest hover:text-gray-300 transition-colors">
              ← Cancel
            </button>
          </form>
        )}

        {/* TOTP enroll step */}
        {step === 'enroll' && <TOTPEnroll onDone={() => setStep('password')} />}
      </motion.div>
    </div>
  )
}

function TOTPEnroll({ onDone }) {
  const [qrUrl,   setQrUrl]   = useState(null)
  const [secret,  setSecret]  = useState(null)
  const [fid,     setFid]     = useState(null)
  const [code,    setCode]    = useState('')
  const [loading, setLoading] = useState(false)
  const [error,   setError]   = useState('')
  const [started, setStarted] = useState(false)

  const startEnroll = async () => {
    setLoading(true)
    const { data, error: err } = await supabase.auth.mfa.enroll({ factorType: 'totp', issuer: 'OrderQ', friendlyName: 'OrderQ Admin' })
    if (err) { setError(err.message); setLoading(false); return }
    setQrUrl(data.totp.qr_code)
    setSecret(data.totp.secret)
    setFid(data.id)
    setStarted(true)
    setLoading(false)
  }

  const verify = async (e) => {
    e.preventDefault()
    setLoading(true); setError('')
    const { data: ch } = await supabase.auth.mfa.challenge({ factorId: fid })
    const { error: ve } = await supabase.auth.mfa.verify({ factorId: fid, challengeId: ch.id, code })
    if (ve) { setError('Invalid code.'); setLoading(false); return }
    onDone()
  }

  const inputCls = `w-full bg-[#121212] border border-white/10 rounded-2xl px-5 py-4 text-white placeholder-gray-500 focus:border-[#f06e28] focus:outline-none focus:ring-1 focus:ring-[#f06e28] transition-all font-medium tracking-wide shadow-inner`

  return (
    <div className="space-y-5 relative z-10">
      <div className="bg-amber-500/10 border border-amber-500/20 rounded-2xl p-4 text-amber-400 text-xs text-center font-bold tracking-wider">
        First Admin Login: Setup Required
      </div>
      {!started ? (
        <button onClick={startEnroll} disabled={loading}
          className="w-full bg-[#f06e28] text-white py-4 rounded-2xl font-bold tracking-widest uppercase text-sm shadow-[0_8px_20px_-4px_rgba(240,110,40,0.4)] disabled:opacity-50 transition-all active:scale-95">
          {loading ? 'Generating...' : 'Setup Authenticator'}
        </button>
      ) : (
        <form onSubmit={verify} className="space-y-5">
          <div className="bg-white rounded-3xl p-5 flex items-center justify-center shadow-inner">
            <img src={qrUrl} alt="TOTP QR" className="w-44 h-44" />
          </div>
          <div className="bg-[#121212] rounded-2xl p-4 text-center border border-white/5 shadow-inner">
            <p className="text-gray-500 text-[10px] uppercase tracking-widest mb-1 font-bold">Manual Key</p>
            <p className="text-[#f06e28] text-xs font-mono tracking-widest break-all font-bold">{secret}</p>
          </div>
          <input type="text" inputMode="numeric" placeholder="000 000" maxLength={6}
            value={code} onChange={e => setCode(e.target.value.replace(/\D/g,''))}
            className={inputCls + ' text-center text-2xl tracking-[0.4em] py-5 font-bold'} autoFocus />
          {error && <p className="text-red-400 text-xs text-center font-bold">{error}</p>}
          <button type="submit" disabled={loading || code.length !== 6}
            className="w-full bg-[#f06e28] text-white py-4 rounded-2xl font-bold tracking-widest uppercase text-sm shadow-[0_8px_20px_-4px_rgba(240,110,40,0.4)] disabled:opacity-50 transition-all active:scale-95">
            {loading ? 'Verifying...' : 'Activate Account'}
          </button>
        </form>
      )}
    </div>
  )
}